import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";

const EditorialImageGrid = ({ editorialImageGridData = {} }) => {
  const {
    text: Title,
    description: Description,
    images = []
  } = editorialImageGridData;

  const imgData = images
    .map(item => ({
      src: item.fields?.imageUrl,
      alt: item.fields?.alt || ""
    }))
    .filter(img => img.src);

  return (
    <section className={styles.section}>
      <div className={styles.wrapper}>
        {/* Title */}
        <div className={styles.title}>
          {Title}
        </div>
        {/* Description */}
        <div className={styles.description}>
          {Description}
        </div>
        {/* Image Gallery */}
        {imgData.length >= 5 && (
          <div className={styles.gallery}>
            {/* Left Stack (2 images) */}
            <div className={styles.stack}>
              <img src={imgData[0].src} alt={imgData[0].alt} />
              <img src={imgData[1].src} alt={imgData[1].alt} />
            </div>
            {/* Center Image */}
            <div className={styles.centerImage}>
              <img src={imgData[2].src} alt={imgData[2].alt} />
            </div>
            {/* Right Stack (2 images) */}
            <div className={styles.stack}>
              <img src={imgData[3].src} alt={imgData[3].alt} />
              <img src={imgData[4].src} alt={imgData[4].alt} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default EditorialImageGrid;

EditorialImageGrid.defaultProps = {
  editorialImageGridData: {
    text: "",
    description: "",
    images: []
  }
};

EditorialImageGrid.propTypes = {
  editorialImageGridData: PropTypes.shape({
    text: PropTypes.string,
    description: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          imageUrl: PropTypes.string.isRequired,
          alt: PropTypes.string
        }).isRequired
      })
    )
  })
};